/**
 * API de ítems (item.php)
 * GET / → lista | GET /{id} → por ID | GET /{sku} o ?sku= → por SKU
 * GET ?service_type= → por tipo de servicio
 * POST / → crear | PUT|PATCH /{id} → actualizar | DELETE /{id} → eliminar
 */

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/item.php';

export const getItems = async (params = {}) => {
  try {
    const response = await dotoniwoofApi.get(BASE, { params });
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener ítems:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const getItemById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener ítem:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const getItemBySku = async (sku) => {
  try {
    const response = await dotoniwoofApi.get(BASE, { params: { sku } });
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener ítem por SKU:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const createItem = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(BASE, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear ítem:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al crear ítem' }
    };
  }
};

export const updateItem = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${BASE}/${id}`, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar ítem:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar ítem' }
    };
  }
};

export const deleteItem = async (id, firebase_UID) => {
  try {
    const response = await dotoniwoofApi.delete(`${BASE}/${id}`, {
      data: { firebase_UID },
      params: { firebase_UID }
    });
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar ítem:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al eliminar ítem' }
    };
  }
};
